import {
  type AttachmentFragment,
  useCreateAssignableFileMutation,
} from "@src/__generated__/urql-graphql";
import { useStore } from "@src/utils/hooks";
import { uniqueId } from "lodash";

export const useUpload = () => {
  const { UIStore } = useStore();
  const [_, upload] = useCreateAssignableFileMutation();

  return () => {
    const controller = new AbortController();
    const uniqId = uniqueId();

    const _upload = async (
      file: File,
    ): Promise<AttachmentFragment | undefined> => {
      UIStore.editorFileUploadMap.set(uniqId, true);

      const result = await upload(
        { file },
        {
          fetchOptions: {
            signal: controller.signal,
            credentials: "include",
          },
        },
      );

      UIStore.editorFileUploadMap.delete(uniqId);
      if (!result.data?.createAssignableFile) return undefined;
      return result.data.createAssignableFile;
    };

    const cancel = () => {
      UIStore.editorFileUploadMap.delete(uniqId);
      controller.abort();
    };

    return { upload: _upload, cancel };
  };
};
